import React from 'react';
import { stageMeta } from '../../lib/stages';

export default function StageChip({ stage, enteredAt = null, className = '' }) {
  const meta = stageMeta(stage);
  const title = enteredAt ? `Entered ${enteredAt}` : undefined;
  return (
    <span
      title={title}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium uppercase tracking-wider border ${meta.tone} ${className}`}
    >
      {meta.label}
    </span>
  );
}
